import React, { Component } from "react";
import Proptypes from "prop-types";

export default class ViewDigitalOceanDnsProviderConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        const { currentDnsProviderConfig } = this.props;
        return (
            <React.Fragment>
                <tr><td><h4>Name</h4></td><td>{currentDnsProviderConfig.config_name || "-"}</td></tr>
                <tr><td><h4>Token</h4></td><td>{currentDnsProviderConfig.digital_ocean_token}</td></tr>
            </React.Fragment>
        );
    }
}

ViewDigitalOceanDnsProviderConfig.propTypes = {
    currentDnsProviderConfig: Proptypes.object.isRequired,
};
